import { Component, OnInit } from '@angular/core';
import { AlertService} from './../services/alert.service';

@Component({
   // moduleId: module.id,
    selector: 'alert',
    template: require('./alert.component.html'),
   // templateUrl: 'alert.component.html'
})

export class AlertComponent {
    message: any;

    constructor(private alertService: AlertService) { }

    ngOnInit() {
        //alert(this.message);
        
        this.alertService.getMessage().subscribe(message => { this.message = message; });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/typescript/_directives/alert.component.ts